import axios from "axios";

export const isHal = (api) => api && api.definitions && api.definitions.hateoas;

export const formURLFromAPISpec = (api) =>
  `${api.schemes}://${api.host}${api.microApiRoute}`;

export const getHeadersFromAPISpec = (api) =>
  (api && api.definitions && api.definitions.headers) || {};

export const requiresAuthentication = (api) =>
  (api && api.definitions && api.definitions.integratorSecurity) || false;

export const isWellFormed = (apiResponse) => apiResponse && apiResponse.links;

export const getStatus = async (spec, url, apiKey) => {
  let headers;
  if (isHal(spec)) {
    if (requiresAuthentication(spec)) {
      headers = Object.assign({}, getHeadersFromAPISpec(spec), {
        "x-api-key": apiKey,
      });
      return callAPI(url, headers);
    } else {
      headers = Object.assign({}, getHeadersFromAPISpec(spec), {
        "x-api-key": apiKey,
      });
      return callAPI(url, headers);
    }
  } else {
    return "NOH";
  }
};

export const callAPI = async (url, headers) => {
  try {
    const response = await axios.options(url, { headers });
    return isWellFormed(response.data) ? "OK" : "NOK";
  } catch (error) {
    console.error("Error calling API:", error);
    return "KO";
  }
};
